import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { BonsaiTree } from "../components/BonsaiTree";

/** Veteran Green Initiative — dark premium band right after the "what EVIQ does" story. */
export const VeteranInitiative = () => (
  <section
    className="relative py-24 sm:py-28 overflow-hidden"
    style={{ background: "linear-gradient(180deg, #030503 0%, #06121a 45%, #030503 100%)" }}
    data-testid="veteran-initiative-section"
  >
    {/* gold hairlines */}
    <div className="absolute inset-x-0 top-0 h-px" style={{ background: "linear-gradient(90deg, transparent, rgba(0,229,255,0.45), transparent)" }} />
    <div className="absolute inset-x-0 bottom-0 h-px" style={{ background: "linear-gradient(90deg, transparent, rgba(0,229,255,0.25), transparent)" }} />
    {/* faint star field accent */}
    <BonsaiTree size={96} className="absolute top-10 right-[8%] opacity-[0.05]" color="#00E5FF" />
    <BonsaiTree size={56} className="absolute bottom-12 left-[6%] opacity-[0.04]" color="#39FF14" />

    <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8 relative">
      <div className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.28em] mb-5" style={{ color: "#00E5FF" }}>
        <ShieldCheck className="w-3.5 h-3.5" /> EVIQ Veteran Green Initiative
      </div>

      <h2 className="text-white font-display font-semibold text-3xl sm:text-4xl lg:text-5xl leading-[1.08] max-w-3xl">
        They powered our mission.
        <br />
        <span style={{ color: "#00E5FF" }}>Now we'll help power theirs.</span>
      </h2>

      <p className="text-zinc-400 text-base sm:text-lg leading-relaxed max-w-2xl mt-6">
        EVIQ is building training pathways, employment partnerships, and a growing forest planted in
        honor of the veterans who served. The first mission is beautifully simple:{" "}
        <span className="text-white font-medium">sponsor EVIQ's first veteran.</span>
      </p>

      <div className="flex flex-wrap items-center gap-3 mt-9">
        <Link
          to="/impact"
          className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 font-mono text-[12px] uppercase tracking-wider font-bold transition-transform hover:scale-[1.03]"
          style={{ background: "#00E5FF", color: "#001114" }}
          data-testid="veteran-explore-impact-btn"
        >
          Explore Our Impact <ArrowRight className="w-4 h-4" />
        </Link>
        <Link
          to="/partners"
          className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 font-mono text-[12px] uppercase tracking-wider font-bold border transition-colors hover:bg-white/5"
          style={{ borderColor: "rgba(0,229,255,0.5)", color: "#A9EDFF" }}
          data-testid="veteran-become-partner-btn"
        >
          <ShieldCheck className="w-4 h-4" /> Become an Impact Partner
        </Link>
      </div>

      <div className="flex flex-wrap gap-x-6 gap-y-2 mt-8">
        {["Training pathways", "Employment partners", "Trees planted in their name"].map((c) => (
          <span key={c} className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wider text-zinc-500">
            <BonsaiTree size={14} color="#00E5FF" /> {c}
          </span>
        ))}
      </div>
    </div>
  </section>
);
